import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    background-color: ${({ hovering, theme }) => (hovering ? theme.colors.neutral000 : theme.colors.white)};
    border: 1px solid ${({ hovering, theme }) => (hovering ? theme.colors.primary300 : theme.colors.neutral100)};
    cursor: ${({ cursor }) => cursor};
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    height: 45px;
    width: 180px;
    transition: 250ms;
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
`;

export const ButtonText = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 12px;
    width: 90px;
`;

export const Label = styled.h3`
    align-items: center;
    color: ${({ theme }) => theme.colors.neutral700};
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    width: 180px;
`;